import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';

import { getBuilderApprovalStatus } from '@/services/api/template-builder';
import { getEsteiraGroup } from '@/services/api/esteira';
import BuilderWorkspace from './components/BuilderWorkspace';

function dedupePages(g: any): any[] {
  const seen = new Set<string>();
  const out: any[] = [];
  for (const p of g?.pages_meta ?? []) {
    const fb = p.fb_page_id ?? '';
    if (!fb || p.is_usable === false || seen.has(fb)) continue;
    seen.add(fb);
    out.push(p);
  }
  return out;
}

export default function BuilderItemPage() {
  const { id } = useParams();
  const itemId = Number(id);
  const navigate = useNavigate();

  const { data: item, isLoading } = useQuery({
    queryKey: ['builder', 'item', itemId],
    queryFn: () => getBuilderApprovalStatus(itemId),
    enabled: !!itemId,
  });

  const { data: esteira } = useQuery({
    queryKey: ['builder', 'esteira-pages', item?.esteira_group_id],
    queryFn: () => getEsteiraGroup(item!.esteira_group_id),
    enabled: !!item?.esteira_group_id,
  });
  const pages = useMemo(() => dedupePages(esteira), [esteira]);

  if (isLoading || !item) return <div className="p-6 text-sm text-muted-foreground">Carregando…</div>;

  return (
    <div className="p-6">
      <div className="mb-5">
        <button onClick={() => navigate('/meta/template-builder')} className="mb-1 flex items-center gap-1 text-sm text-muted-foreground hover:text-slate-900">
          <ArrowLeft className="h-4 w-4" /> Template Builder
        </button>
        <h1 className="text-xl font-semibold">{item.name ?? `Peça #${item.id}`}</h1>
      </div>
      <BuilderWorkspace
        esteiraGroupId={item.esteira_group_id}
        esteiraName={esteira?.name}
        folderId={item.folder_id ?? null}
        projectId={null}
        pages={pages}
        existingItem={item}
        onSaved={() => navigate('/meta/template-builder')}
      />
    </div>
  );
}
